import Spline, { type SplineType } from "@/lib/spline"
import { clamp } from "@/utils/math"

import { Adjustments } from "@/core/types"

type IPoint = [number, number]
type IPoints = IPoint[]

const offsets = {
	red: 0,
	green: 1,
	blue: 2,
	all: 3,
}

const curveSize = 4096
const textureData = new Float32Array(curveSize * 4)

const defaultCurvePoints: Array<[number, number]> = [
	[0, 0],
	[255, 255],
]

export function isIdentityCurve(points: Array<[number, number]>): boolean {
	if (points.length !== defaultCurvePoints.length) return false
	return points.every(
		(p, i) => p[0] === defaultCurvePoints[i]?.[0] && p[1] === defaultCurvePoints[i]?.[1],
	)
}

function transformPoints(points: IPoints) {
	const res = [[], []] as [number[], number[]]
	for (const point of points) {
		res[0].push(point[0])
		res[1].push(point[1])
	}
	return res
}

export function interpolate(spline: SplineType, i: number, p: number) {
	const v = clamp(spline.at(i), 0, 255)
	return isNaN(v) ? p : v
}

export function getCurvesData(values: Adjustments): Float32Array {
	const channels = {
		all: values.curvesAll,
		red: values.curvesRed,
		green: values.curvesGreen,
		blue: values.curvesBlue,
	}

	for (const channel in channels) {
		const offset = offsets[channel]
		const points = transformPoints(channels[channel])
		const pointsSpline = new Spline(points[0], points[1])

		let point = points[1][0] || 0

		for (let i = 0; i < curveSize; i++) {
			point = interpolate(pointsSpline, (i / (curveSize - 1)) * 255, point)
			textureData[i * 4 + offset] = point / 255.0
		}
	}

	return textureData
}
